import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatFormFieldModule } from '@angular/material/form-field';
import { JobportalRoutingModule } from './jobportal-routing.module';
import { JobportalComponent } from './jobportal/jobportal.component';
import { JobdetailComponent } from './jobdetail/jobdetail.component';
import { ApplicationComponent } from './application/application.component';
import { SuccessComponent } from './success/success.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonAppModuleModule } from '../common-app-module/common-app-module.module';
import { JobFilterComponent } from './jobportal/job-filter/job-filter.component';
import { SharedComponentsModule } from '../shared/modules/shared-components/shared-components.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { JobsSharedModule } from '../jobs-shared/jobs-shared.module';

@NgModule({
  declarations: [JobportalComponent, JobdetailComponent, ApplicationComponent, SuccessComponent, JobFilterComponent],
  imports: [
    CommonModule,
    JobportalRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ModalModule.forRoot(),
    MatFormFieldModule,
    NgSelectModule,
    CommonAppModuleModule,
    SharedComponentsModule,
    InfiniteScrollModule,
    JobsSharedModule
  ]
})
export class JobportalModule { }
